import { jsx as _jsx } from "react/jsx-runtime";
import { Fieldset } from "@headlessui/react";
function WPQTFieldSet({ children, className }) {
    return (_jsx(Fieldset, { className: `wpqt-border-none ${className}`, children: children }));
}
export { WPQTFieldSet };
